import axios from "axios";
import authTokenInterceptor from "../interceptors/auth-token-iw.interceptor";
import spinnerInterceptor from "../interceptors/spinner.interceptor";

const http = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/com.appetize.ppi.web.v0.1.82+json;charset=UTF-8",
    Accept: "*/*"
  }
});

authTokenInterceptor.wrapAxios(http);
spinnerInterceptor.wrapAxios(http);

function getDiscounts(accountId, paymentType, subPaymentType, payload, showSpinner = true) {
  return http.post(
    "/payment-partner-integrations/getDiscounts",
    {
      ...payload
    },
    {
      showSpinner,
      headers: {
        accountId: accountId,
        paymentType: paymentType,
        subpaymentType: subPaymentType
      }
    }
  );
}

function processPayment(accountId, paymentType, subPaymentType, payload, showSpinner = true) {
  return http.post(
    "/payment-partner-integrations/process",
    {
      ...payload
    },
    {
      showSpinner,
      headers: {
        accountId: accountId,
        paymentType: paymentType,
        subPaymentType: subPaymentType
      }
    }
  );
}

function reportOrder(accountId, paymentType, subPaymentType, payload, showSpinner = true) {
  return http.post(
    "/payment-partner-integrations/reportOrder",
    {
      ...payload
    },
    {
      showSpinner,
      headers: {
        accountId: accountId,
        paymentType: paymentType,
        subPaymentType: subPaymentType
      }
    }
  );
}

function useReductions(accountId, paymentType, subPaymentType, payload, showSpinner = true) {
  return http.post(
    "/payment-partner-integrations/useReductions",
    {
      ...payload
    },
    {
      showSpinner,
      headers: {
        accountId: accountId,
        paymentType: paymentType,
        subPaymentType: subPaymentType
      }
    }
  );
}

function voidPayment(accountId, paymentType, subPaymentType, payload, showSpinner = true) {
  return http.post(
    "/payment-partner-integrations/void",
    {
      ...payload
    },
    {
      showSpinner,
      headers: {
        accountId: accountId,
        paymentType: paymentType,
        subPaymentType: subPaymentType
      }
    }
  );
}

export default {
  getDiscounts,
  processPayment,
  reportOrder,
  useReductions,
  voidPayment
};
